import { IconButton } from '@nexelem/components';
import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { SingleDetailLabel } from './SingleDetailLabel';
import { cn } from '@nexelem/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-light-svg-icons';

type SingleDetailProps = {
  title: ReactNode;
  content: string | ReactNode;
  withBg?: boolean;
  isEditable?: boolean;
  onClick?: () => void;
  isLoading?: boolean;
  LoadingElement?: ReactNode;
  compactText?: boolean;
  isJumbo?: boolean;
  noSidePadding?: boolean;
};

export const SingleDetail = ({
  title,
  content,
  withBg = false,
  isEditable = false,
  onClick,
  compactText,
  isLoading,
  LoadingElement,
  isJumbo = false,
  noSidePadding = false,
}: SingleDetailProps) => (
  <div
    className={cn(
      'relative flex flex-col rounded-xs',
      withBg && 'border border-border-secondary bg-surface-container-lighter px-2 py-4',
      !compactText && 'gap-1',
    )}
  >
    <SingleDetailLabel noSidePadding={noSidePadding} size={isJumbo ? 'jumbo' : undefined}>
      {title}
    </SingleDetailLabel>
    {isEditable && (
      <IconButton
        className="absolute top-2 right-2"
        Icon={<FontAwesomeIcon icon={faPen} />}
        size={isJumbo ? 'large' : 'small'}
        onClick={onClick}
      />
    )}

    <div
      className={clsx(
        isJumbo ? 'text-s24' : 'text-s18',
        compactText ? 'py-0' : 'py-1',
        noSidePadding ? 'px-0' : 'px-2',
      )}
    >
      {isLoading ? LoadingElement : content}
    </div>
  </div>
);
